import Image from "next/image";
import Link from "next/link";

/** COLORS wordmark used in the top-left corner and the phone bands. */
export function EditorialWordmark({ href = "/" }: { href?: string }) {
	return (
		<Link
			href={href}
			aria-label="COLORS home"
			style={{ display: "inline-flex", padding: "1px 0" }}
		>
			<Image
				src="/logo--white.svg"
				alt=""
				width={171}
				height={12}
				className="ed-wordmark"
				aria-hidden
				priority
			/>
		</Link>
	);
}
